import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Search } from "lucide-react";
import { usePageMeta } from "@/lib/seo";

const DEPARTMENTS = ["Recliners", "Furniture", "E-Bikes", "Scooters", "Appliances", "Tools & Hardware"];

export default function NotFoundPage() {
  usePageMeta("Page Not Found", "That page doesn't exist — search the store or browse departments at IPVALUE MARKETPLACE, Grand Rapids MI.", { noindex: true });
  const nav = useNavigate();
  const [q, setQ] = useState("");

  return (
    <div className="max-w-[860px] mx-auto px-6 py-20 text-center" data-testid="not-found-page">
      <div className="ipv-eyebrow text-[#C9971E]">404 — page not found</div>
      <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter text-[#0A1C40] mt-3">
        That aisle doesn't exist.
      </h1>
      <p className="text-gray-600 mt-3">
        The page you're looking for moved or never existed — but the deals are still here.
      </p>
      <form
        onSubmit={(e) => { e.preventDefault(); if (q.trim()) nav(`/shop?q=${encodeURIComponent(q.trim())}`); }}
        className="mt-8 max-w-md mx-auto relative"
      >
        <Search className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
        <input
          className="input-base !pl-11 !rounded-full w-full"
          placeholder="Search recliners, pallets, e-bikes…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          data-testid="notfound-search"
        />
      </form>
      <div className="mt-8 flex flex-wrap justify-center gap-2">
        {DEPARTMENTS.map((d) => (
          <Link key={d} to={`/shop/${d}`} className="px-4 py-2 border-2 border-gray-200 hover:border-[#0A1C40] text-sm font-bold rounded-full transition-colors">
            {d}
          </Link>
        ))}
        <Link to="/pallets" className="px-4 py-2 bg-[#FFC220] text-[#0A1C40] text-sm font-black rounded-full">
          Pallet Sales
        </Link>
      </div>
      <Link to="/" className="inline-block mt-10 bg-[#0A1C40] text-white font-bold px-8 py-3.5 rounded-full hover:bg-[#152b59] transition-colors" data-testid="notfound-home-link">
        Back to the homepage
      </Link>
    </div>
  );
}
